import devtools from "@vue/devtools";
import Vue, { h } from "vue";
import App from "@/App.vue";
import "@/registerServiceWorker";
import router from "@/router";
import Axios from "vue-axios";
import axios from "axios";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import SweetAlert from "vue-sweetalert2";
import EventBus from "vue-bus-ts";
import VueSlider from "vue-slider-component";
import VShowSlide from "v-show-slide";
import InlineSvg from "vue-inline-svg";
import PortalVue from "portal-vue";
import FloatingVue from "floating-vue";

import { Amplify } from "aws-amplify";
import { useAxios } from "@/config";
import BootstrapVue, { BootstrapVueIcons } from "bootstrap-vue";
import { PiniaVuePlugin } from "pinia";
import pinia, { useApi, useAuth, useLayout } from "@/services";
import VueMarkdownLite from "@earthtone/vue-markdown-lite";
import { DirectiveBinding } from "vue/types/options";
import { patchScrollBlockingListeners } from "@/util/patch-scroll-blocking-listeners";
import VJsonEditor from "v-jsoneditor";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import "@/assets/style/v/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.min.css";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-slider-component/theme/antd.css";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "floating-vue/dist/style.css";

import "brace";
import "brace/theme/chrome";
import { InitSettings } from "./types";

gsap.registerPlugin(ScrollToPlugin);

const useDevTools = +(process.env.VUE_APP_USE_DEVTOOLS || 0);
if (useDevTools) {
  console.clear();
  devtools.connect("http://localhost:8098");
}

Vue.config.ignoredElements = [/amplify-\w*/];
Vue.config.productionTip = false;
Vue.use(PiniaVuePlugin);
Vue.use(BootstrapVueIcons);
Vue.use(BootstrapVue);
Vue.use(Axios, axios);
Vue.use(PerfectScrollbar);
Vue.use(SweetAlert);
Vue.use(EventBus);
Vue.use(VShowSlide);
Vue.use(PortalVue);
Vue.use(FloatingVue, {
  container: "#app",
});
Vue.use(VueMarkdownLite);
Vue.use(VJsonEditor);

Vue.component("vue-slider", VueSlider);
Vue.component("inline-svg", InlineSvg);
Vue.directive("canvas-row", {
  inserted(el: HTMLElement, binding: DirectiveBinding) {
    const canvas = binding.value;
    if (canvas instanceof HTMLCanvasElement) {
      const c = document.createElement("canvas");
      const ctx = c.getContext("2d");
      c.width = canvas.width;
      c.height = canvas.height;
      if (ctx) {
        ctx.drawImage(canvas, 0, 0);
      }
      el.appendChild(canvas);
    }
  },
});
Vue.config.productionTip = false;

const Instance = new Vue({
  el: "#devHook",
  name: "PerilFinder",
  bus: new EventBus.Bus(),
  router,
  pinia,
  beforeMount() {
    patchScrollBlockingListeners();
    if (useDevTools) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "http://localhost:8098";
      document.head.appendChild(s);
    }

    // const headers = {
    //   RefererUrl:
    //     window.location.hostname === "localhost"
    //       ? process.env.VUE_APP_REFERER_URL
    //       : window.location.href,
    // };
    axios
      //TEST Multitenant API
      //.get<InitSettings>(useApi(pinia).initSettings, { headers })
      .get<InitSettings>(useApi(pinia).initSettings)
      .then((result) => {
        const { cognitoSettings, layoutSettings } = result.data;
        useAuth(pinia).setCognitoSettings(cognitoSettings);

        const { origin } = location;
        const redirectUrl = origin + (process.env.VUE_APP_STAGE || "");

        Amplify.configure({
          ...cognitoSettings,
          authenticationFlowType: "USER_PASSWORD_AUTH",
          oauth: {
            ...cognitoSettings.oAuth,
            redirectSignIn: redirectUrl,
            redirectSignOut: redirectUrl,
            responseType: "code",
          },
        });

        useLayout(pinia).set(layoutSettings as any);
        useAuth(pinia).isInstanceReady = true;
      });
  },
  render: () => h(App),
});

export const { $bus, $router, $bvModal } = Instance;

useAxios().setupAxios($bvModal);
export default Instance;
